import { FORMIK_EMPTY_VALUE } from '../../../constants/validation'

export const INIT_STAGE = 'init'

export const CARD_STAGE = 'card'

export const LOAD_STAGE = 'load'

export const RESTORE_STAGE = 'restore'

export const PROLONG_TIMEOUT = 1000 * 60 * 3

export const REQUEST_WIZARD_CARD_TEXT_TYPE = 'text'

export const REQUEST_WIZARD_CARD_IMAGE_TYPE = 'image'

export const REQUEST_WIZARD_CARD_VARIABLE_TYPE = 'variable'

export const REQUEST_WIZARD_CARD_LINK_TYPE = 'link'

export const REQUEST_WIZARD_CHUNK_WORKFLOW_RESULT_TYPE = 'workflow_result'

export const REQUEST_WIZARD_CHUNK_PARAM_NAME_WITH_CREATED_REQUESTS =
  'with_created_requests'

export const REQUEST_WIZARD_CHUNK_PARAMS = {
  [REQUEST_WIZARD_CHUNK_PARAM_NAME_WITH_CREATED_REQUESTS]: true,
}

export const REQUEST_WIZARD_FIELD_STRING_VARIABLE_TYPE = 'string'

export const REQUEST_WIZARD_FIELD_DECIMAL_VARIABLE_TYPE = 'decimal'

export const REQUEST_WIZARD_FIELD_EMAIL_VARIABLE_TYPE = 'email'

export const REQUEST_WIZARD_FIELD_PHONE_VARIABLE_TYPE = 'phone'

export const REQUEST_WIZARD_FIELD_TEXT_VARIABLE_TYPE = 'text'

export const REQUEST_WIZARD_FIELD_FILE_VARIABLE_TYPE = 'file'

export const REQUEST_WIZARD_FIELD_LINK_TYPE = 'link'

export const REQUEST_WIZARD_INIT_STAGE_FIELD_NAME_BUILDING = 'building'

export const REQUEST_WIZARD_INIT_STAGE_FIELD_NAME_FLAT = 'flat'

export const REQUEST_WIZARD_INIT_STAGE_FIELD_NAME_MANAGER = 'manager'

export const REQUEST_WIZARD_INIT_STAGE_FIELD_NAME_USER = 'user'

export const REQUEST_WIZARD_INIT_STAGE_FIELD_NAME_CONTRACT = 'contract'

export const REQUEST_WIZARD_INIT_STAGE_VARIABLE_NAME_PROFILE = 'profile_id'

export const REQUEST_WIZARD_INIT_STAGE_VARIABLE_NAME_BUILDING = 'building_id'

export const REQUEST_WIZARD_INIT_STAGE_VARIABLE_NAME_FLAT = 'flat_id'

export const REQUEST_WIZARD_INIT_STAGE_VARIABLE_NAME_MANAGER = 'manager_id'

export const REQUEST_WIZARD_INIT_STAGE_VARIABLE_NAME_EMAIL_MESSAGE =
  'email_message'

export const REQUEST_WIZARD_INIT_STAGE_VARIABLE_NAME_CHAT_MESSAGE =
  'chat_message'

export const REQUEST_WIZARD_INIT_STAGE_VARIABLE_NAME_POST = 'post'

export const REQUEST_WIZARD_INIT_STAGE_VARIABLE_NAME_IS_CHATROOM_PUBLIC =
  'is_chatroom_public'

export const REQUEST_WIZARD_INIT_PAYLOAD_FIELD_NAME_ORIGINAL_REQUEST =
  'original_request_id'

export const REQUEST_WIZARD_FORM_INIT_STAGE_INITIAL_VALUES = {
  [REQUEST_WIZARD_INIT_STAGE_FIELD_NAME_BUILDING]: FORMIK_EMPTY_VALUE,
  [REQUEST_WIZARD_INIT_STAGE_FIELD_NAME_CONTRACT]: FORMIK_EMPTY_VALUE,
  [REQUEST_WIZARD_INIT_STAGE_FIELD_NAME_FLAT]: FORMIK_EMPTY_VALUE,
  [REQUEST_WIZARD_INIT_STAGE_FIELD_NAME_MANAGER]: FORMIK_EMPTY_VALUE,
  [REQUEST_WIZARD_INIT_STAGE_FIELD_NAME_USER]: FORMIK_EMPTY_VALUE,
}

export const REQUEST_WIZARD_AI_WIZARD_SELECT_KEY_PREFIX = 'select__card_'

export const REQUEST_WIZARD_AI_WIZARD_NOTIFICATION_ID =
  'request-wizard-ai-wizard'

export const QA_NAME_REQUEST_WIZARD_AI_WIZARD_BUTTON =
  'request_wizard_ai_wizard_button'

// AI Wizard init-stage response key → Formik field name
export const REQUEST_WIZARD_AI_WIZARD_INIT_STAGE_FIELD_BY_RESPONSE_KEY = {
  [REQUEST_WIZARD_INIT_STAGE_VARIABLE_NAME_BUILDING]:
    REQUEST_WIZARD_INIT_STAGE_FIELD_NAME_BUILDING,
  [REQUEST_WIZARD_INIT_STAGE_VARIABLE_NAME_FLAT]:
    REQUEST_WIZARD_INIT_STAGE_FIELD_NAME_FLAT,
  [REQUEST_WIZARD_INIT_STAGE_VARIABLE_NAME_PROFILE]:
    REQUEST_WIZARD_INIT_STAGE_FIELD_NAME_USER,
}

export const REQUEST_WIZARD_CREATION_FORM_SERVER_ERROR_UNABLE_TO_PERFORM_ACTION =
  'You_do_not_have_permission_to_perform_this_action'

export const REQUEST_WIZARD_CREATION_FORM_SERVER_ERROR_MANAGER_ASSIGN_FORBIDDEN =
  'Dwellers or landlords cannot manually assign managers'

export const REQUEST_WIZARD_CREATION_FORM_SERVER_ERRORS = {
  [REQUEST_WIZARD_CREATION_FORM_SERVER_ERROR_MANAGER_ASSIGN_FORBIDDEN]:
    'Error.RequestWizardFormManagerAssignForbiddenKey',
  [REQUEST_WIZARD_CREATION_FORM_SERVER_ERROR_UNABLE_TO_PERFORM_ACTION]:
    'Error.RequestWizardFormUnableToPerformActionKey',
}
